import { makeStyles } from '@material-ui/core';

const makeClasses = makeStyles(theme => ({
  container: {
    padding: theme.spacing(1),
  },
}));

export default makeClasses;
